import ScheduleDate from "./ScheduleDate";
import ScheduleTime from "./ScheduleTime";
import { SCHEDULE_TYPES, ScheduleTaskProps } from "./types";

const ScheduleTask = ({
    schedule,
    format,
    shouldBeAdjusted
}: ScheduleTaskProps) => {
    const renderValue = () => {
        if (!schedule) return "-";

        const {
            type,
            attributes: { from_date, to_date, from_minutes, duration_minutes }
        } = schedule;

        return type === SCHEDULE_TYPES.SpecificDays ? (
            <ScheduleDate
                fromDate={from_date!}
                toDate={to_date!}
                format={format}
                shouldBeAdjusted={shouldBeAdjusted}
            />
        ) : (
            <ScheduleTime
                fromMinutes={from_minutes!}
                durationMinutes={duration_minutes!}
            />
        );
    };

    return renderValue();
};

export default ScheduleTask;
export { SCHEDULE_TYPES };
